import { useState, useCallback } from 'react';
/**
 * ページネーション (ローディング用) hook
 */
export const useLoadingPagination = (args) => {
    const { initialItemCount = 3, itemCount, onPageChange } = args;
    // ページ切り替え前の表示件数
    const [prevItemCount, changePrevItemCount] = useState(initialItemCount);
    /**
     * ページ切り替え前の表示件数 state 管理 + onPageChange
     */
    const wrapOnPageChange = useCallback((selected) => {
        changePrevItemCount(itemCount !== null && itemCount !== void 0 ? itemCount : initialItemCount);
        onPageChange(selected);
    }, [initialItemCount, itemCount, onPageChange]);
    return {
        onPageChange: wrapOnPageChange,
        prevItemCount,
    };
};
